<template>
    <transition name="fade">
        <div>
            <div class="snow"></div>
            <FanKuan class="body"/>
            <transition name="fade">
                <div class="btns" v-if="show">
                    <div :class="['btn', {active: i === 1}]" @touchend="xianliao" @touchstart="i = 1"></div>
                    <div :class="['btn', {active: i === 2}]" @touchend="jinwu" @touchstart="i = 2"></div>
                    <div :class="['btn', {active: i === 3}]" @touchend="duishi" @touchstart="i = 3"></div>
                </div>
            </transition>
            <DialogBox :text="dialog" v-if="dialog" :left="dsLeft"/>
            <DuiShi v-if="ds" @result="result" :dsIndex="dsIndex"/>
            <SubTitle :fontText="text" class="text" v-if="text"></SubTitle>
            <img src="/img/xj/pass.gif" alt="" class="pass" v-if="pass">
        </div>
    </transition>
</template>

<script>
import SubTitle from '@page/xuejinghanlintu/components/SubTitle';
import DialogBox from '@page/xuejinghanlintu/components/Dialog';
import DuiShi from '@page/xuejinghanlintu/components/DuiShi';
import FanKuan from '@page/xuejinghanlintu/components/FanKuan';

export default {
    components: {
        FanKuan,
        DuiShi,
        DialogBox,
        SubTitle
    },
    data() {
        return {
            i: 0,
            pass: false,
            ds: false,
            timer: null,
            show: true,
            dsLeft: false,
            dialog: '',
            text: 1,
            dsIndex: 0,
            dsText: [
                '钟鼓馔玉不足贵',
                '筝人劝我金屈卮',
                '一春梦雨常飘瓦'
            ]
        };
    },
    methods: {
        xianliao() {
            this.i = 0;
            clearTimeout(this.timer);
            this.show = false;
            this.text = 2;
            this.timer = setTimeout(() => {
                this.dialog = '吾初学画时，师从名师，然不得其意，后窥天地自然，方悟“与其师于人者，未若师诸造化”，遂久居终南、太华。自出机杼，岂不妙哉。';
                this.timer = setTimeout(() => {
                    this.back();
                }, 2000);
            }, 1900);
        },
        jinwu() {
            this.i = 0;
            clearTimeout(this.timer);
            this.dialog = '寒舍鄙陋，不便入内。';
            this.show = false;
            this.timer = setTimeout(() => {
                this.dialog = '';
                this.show = true;
            }, 2000);
        },
        duishi() {
            this.i = 0;
            clearTimeout(this.timer);
            this.text = false;
            this.show = false;

            this.dsIndex = Math.floor(Math.random() * 3);
            this.dialog = this.dsText[this.dsIndex];

            this.dsLeft = true;
            setTimeout(() => {
                this.ds = true;
            }, 800);
        },
        result(flg) {
            clearTimeout(this.timer);
            this.ds = false;
            this.text = false;
            if (flg) {
                this.pass = true;
                this.dialog = '';
                this.timer = setTimeout(() => {
                    this.$emit('next', 5);
                }, 3000);
            }
            else {
                this.dialog = '年轻人，诗酒趁年华，莫虚度、莫蹉跎啊。';
                this.timer = setTimeout(() => {
                    this.text = false;
                    this.show = false;

                    this.dialog = this.dsText[this.dsIndex];
                    this.ds = true;
                }, 2000);
            }
        },
        back() {
            clearTimeout(this.timer);
            this.show = true;
            this.ds = false;
            this.text = 1;
            this.dialog = '';
        }
    }
};
</script>

<style lang="stylus" scoped>
@keyframes xue
    from
        background-position-x 0%
    to
        background-position-x 100%
#page
    background url('/img/xj/lv2.png') no-repeat
    background-size cover
    background-position center bottom
    z-index 3 !important
    .snow
        position absolute
        top 4rem
        right 0.5rem
        size 2rem 3rem
        background url('/img/xj/lv4_snow.png') no-repeat
        background-size auto 100%
        background-position-y 0
        animation xue 4s steps(69, end) infinite
    .btns
        position absolute
        width 2.7rem
        left .5rem
        top 4rem
        .btn
            size 100% .87rem
            filter blur(12px)
            opacity 0
            animation show .6s cubic-bezier(0.55, 0.085, 0.68, 0.53)
            animation-fill-mode forwards
            &:nth-child(1)
                background url('/img/xj/btn_chat.png') 0 0/100% 100% no-repeat
            &:nth-child(2)
                background url('/img/xj/btn_enter.png') 0 0/100% 100% no-repeat
                animation-delay .5s
            &:nth-child(3)
                background url('/img/xj/btn_question.png') 0 0/100% 100% no-repeat
                animation-delay 1s
            &.active
                transform scale(1.1);
                transition all .3s;
    .body
        position absolute
        bottom 3.5rem
        left 2.1rem
    .text
        position absolute
        bottom .2rem
        left 50%
        transform translate3d(-50%,0,1px)
    .pass
        width 3.6rem
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
</style>
